/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataEntity } from '../models/data-entity';
import { DataEntityDto } from '../models/data-entity-dto';
import { DataEntityVersionChanges } from '../models/data-entity-version-changes';
import { NewDataEntity } from '../models/new-data-entity';
import { NewVirtualDataEntity } from '../models/new-virtual-data-entity';
import { UpdateDataEntity } from '../models/update-data-entity';
import { UpdateVirtualDataEntity } from '../models/update-virtual-data-entity';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class DataEntitiesControllerService extends DataBaseService {

  /**
   * Path part for operation dataEntitiesControllerCount
   */
  static readonly DataEntitiesControllerCountPath = '/v1/entities/count';

  /**
   * Get count of data entities in the system
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get count of data entities in the system
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataEntitiesControllerUpdateVirtualEntityById
   */
  static readonly DataEntitiesControllerUpdateVirtualEntityByIdPath = '/v1/entities/virtual/{id}';

  /**
   * Update data entity by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVirtualEntityById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVirtualEntityById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: UpdateVirtualDataEntity
  }): Observable<StrictHttpResponse<DataEntity>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerUpdateVirtualEntityByIdPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntity>;
      })
    );
  }
  /**
   * Update data entity by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateVirtualEntityById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVirtualEntityById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: UpdateVirtualDataEntity
  }): Observable<DataEntity> {

    return this.updateVirtualEntityById$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntity>) => r.body as DataEntity)
    );
  }

  /**
   * Path part for operation dataEntitiesControllerCreateVirtual
   */
  static readonly DataEntitiesControllerCreateVirtualPath = '/v1/entities/virtual';

  /**
   * Create a new virtual data entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVirtual()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVirtual$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewVirtualDataEntity
  }): Observable<StrictHttpResponse<DataEntity>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerCreateVirtualPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntity>;
      })
    );
  }
  /**
   * Create a new virtual data entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createVirtual$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVirtual(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewVirtualDataEntity
  }): Observable<DataEntity> {

    return this.createVirtual$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntity>) => r.body as DataEntity)
    );
  }

  /**
   * Path part for operation dataEntitiesControllerGetEntityVersionChanges
   */
  static readonly DataEntitiesControllerGetEntityVersionChangesPath = '/v1/entities/{entity}/breaking-changes/{version}';

  /**
   * Get breaking changes for an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEntityVersionChanges()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEntityVersionChanges$Response(params: {
    entity: string;
    version: number;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntityVersionChanges>>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerGetEntityVersionChangesPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('version', params.version, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntityVersionChanges>>;
      })
    );
  }
  /**
   * Get breaking changes for an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEntityVersionChanges$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEntityVersionChanges(params: {
    entity: string;
    version: number;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntityVersionChanges>> {

    return this.getEntityVersionChanges$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntityVersionChanges>>) => r.body as Array<DataEntityVersionChanges>)
    );
  }

  /**
   * Path part for operation dataEntitiesControllerFindById
   */
  static readonly DataEntitiesControllerFindByIdPath = '/v1/entities/{id}';

  /**
   * Get a single data entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
    includeMainTitleFields?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataEntityDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.query('includeMainTitleFields', params.includeMainTitleFields, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntityDto>;
      })
    );
  }
  /**
   * Get a single data entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
    includeMainTitleFields?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataEntityDto> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntityDto>) => r.body as DataEntityDto)
    );
  }

  /**
   * Path part for operation dataEntitiesControllerDeleteById
   */
  static readonly DataEntitiesControllerDeleteByIdPath = '/v1/entities/{id}';

  /**
   * Delete a data entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete a data entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataEntitiesControllerUpdateById
   */
  static readonly DataEntitiesControllerUpdateByIdPath = '/v1/entities/{id}';

  /**
   * Update data entity by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: UpdateDataEntity
  }): Observable<StrictHttpResponse<DataEntity>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntity>;
      })
    );
  }
  /**
   * Update data entity by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: UpdateDataEntity
  }): Observable<DataEntity> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntity>) => r.body as DataEntity)
    );
  }

  /**
   * Path part for operation dataEntitiesControllerFind
   */
  static readonly DataEntitiesControllerFindPath = '/v1/entities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntityDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntityDto>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntityDto>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntityDto>>) => r.body as Array<DataEntityDto>)
    );
  }

  /**
   * Path part for operation dataEntitiesControllerCreate
   */
  static readonly DataEntitiesControllerCreatePath = '/v1/entities';

  /**
   * Create a new data entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataEntity
  }): Observable<StrictHttpResponse<DataEntity>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntity>;
      })
    );
  }
  /**
   * Create a new data entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataEntity
  }): Observable<DataEntity> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntity>) => r.body as DataEntity)
    );
  }

  /**
   * Path part for operation dataEntitiesControllerGetEntityVersionChangesV2
   */
  static readonly DataEntitiesControllerGetEntityVersionChangesV2Path = '/v2/entities/{entity}/breaking-changes';

  /**
   * Get breaking changes for multiple entity versions (v2)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEntityVersionChangesV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEntityVersionChangesV2$Response(params: {
    entity: string;
    versions?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntityVersionChanges>>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntitiesControllerService.DataEntitiesControllerGetEntityVersionChangesV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('versions', params.versions, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntityVersionChanges>>;
      })
    );
  }
  /**
   * Get breaking changes for multiple entity versions (v2)
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEntityVersionChangesV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEntityVersionChangesV2(params: {
    entity: string;
    versions?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntityVersionChanges>> {

    return this.getEntityVersionChangesV2$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntityVersionChanges>>) => r.body as Array<DataEntityVersionChanges>)
    );
  }

}
